import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ServiceManagerPage } from './service-manager.page';

const routes: Routes = [
  {
    path: '',
    component: ServiceManagerPage
  },
  {
    path: 'all-stylist-service-form',
    loadChildren: () => import('./all-stylist-service-form/all-stylist-service-form.module').then( m => m.AllStylistServiceFormPageModule)
  },
  {
    path: 'all-stylist-service-manager',
    loadChildren: () => import('./all-stylist-service-manager/all-stylist-service-manager.module').then( m => m.AllStylistServiceManagerComponentModule)
  },
  {
    path: 'single-stylist-service-manager',
    loadChildren: () => import('./single-stylist-service-manager/single-stylist-service-manager.module').then( m => m.SingleStylistServiceManagerComponentModule)
  }, 
  {
    path: 'service-category-picker',
    loadChildren: () => import('../service-category-picker/service-category-picker.module').then( m => m.ServiceCategoryPickerComponentModule)
  },  {
    path: 'all-stylist-service-add-category',
    loadChildren: () => import('./all-stylist-service-add-category/all-stylist-service-add-category.module').then( m => m.AllStylistServiceAddCategoryPageModule)
  }


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServiceManagerPageRoutingModule {}
